import React from "react";
import { Route } from "react-router-dom";
import {
  PubEvents,
  BookEvent,
  EventDetails2,
} from "@zillout/shared-components";

export const eventRoutes = (
  <>
    <Route
      path="/pub/detail/events/:pubId"
      element={<PubEvents appContext="experience" />}
    />
    <Route
      path="/event/booking/:eventId"
      element={<BookEvent appContext={"experience"} />}
    />
    <Route
      path="/event/detail/:eventId"
      element={<EventDetails2 appContext="experience" />}
    />
  </>
);
